import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import AuctionWinnerIcon from '../../../assets/svg/auction-winner.svg';
import { theme } from '../../../assets/styles/theme';
import { TextMain } from '../../typography/Texts';

const Container = styled.div`
  display: flex;
  background-color: ${theme.color.red};
  flex-direction: row;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  border-radius: 5px;
  height: 26px;
  padding: 0 12px;
  margin-top: 5px;
`;

const WinnerText = styled(TextMain)`
  color: ${theme.color.white};
  margin-left: 5px;
`;

const BadgeIcon = styled.img`
  width: 16px;
  height: 16px;
`;

const WinnerBadge = () => {
  const { t } = useTranslation('onsite');

  return (
    <Container>
      <BadgeIcon src={AuctionWinnerIcon} />
      <WinnerText>{t('bids.winner')}</WinnerText>
    </Container>
  );
};

export default WinnerBadge;
